import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid, Paper } from '@mui/material';
//===============

const FloatingOnlyConfig = ({ keyData, featureDescription }) => {
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper
			style={{ paddingBottom: '6rem' }}
			className={commonStyleClasses.mainPagePaperMarginStyle}
		>
			<PageHeading
				headingName="Floating Only Config"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Floating Only Config']}
				description="Manage Platform Wise Floating Only Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<Grid container spacing={1} style={{ width: '97%', margin: '2rem auto' }}>
				<Grid item xs={4}>
					<FloatingOnlyPlatformConfig keyData={keyData + '.DESKTOP'} title={'DESKTOP'} />
				</Grid>

				<Grid item xs={4}>
					<FloatingOnlyPlatformConfig keyData={keyData + '.MOBILE'} title={'MOBILE'} />
				</Grid>
				<Grid item xs={4}>
					<FloatingOnlyPlatformConfig keyData={keyData + '.TABLET'} title={'TABLET'} />
				</Grid>
			</Grid>
		</Paper>
	);
};

const FloatingOnlyPlatformConfig = ({ keyData, title }) => {
	const commonStyleClasses = useCommonStyles();

	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Box
			className={commonStyleClasses.basicOutlinedBox}
			style={{ margin: '4rem auto', width: '90%' }}
		>
			<Typography fontWeight={600} variant="h4">
				{title}
			</Typography>

			<CheckBoxInput
				keyData={keyData + '.enabled'}
				label="enabled"
				disabled={false}
				defaultChecked={false}
				object={rawConfig}
				updateObject={updateRawConfig}
				containerStyles={{ width: 'fit-content', margin: '2.5rem 0 .5rem 0' }}
			/>
			<CheckBoxInput
				keyData={keyData + '.shouldDisposePlayer'}
				label="disposePlayer"
				disabled={false}
				defaultChecked={false}
				object={rawConfig}
				updateObject={updateRawConfig}
				containerStyles={{ width: 'fit-content', margin: '0' }}
			/>
		</Box>
	);
};
export default FloatingOnlyConfig;
